export function detectContentType(content) {
	if (!content) return 'text';

	let type = 'text';
	if (content.source_type) {
		if (content.source_type === "Document URL") {
			const url = content.storage_url || content.file_path || content.source_url || "";
			const lowerUrl = url.toLowerCase();
			if (lowerUrl.endsWith('.txt')) type = 'txt';
			else if (lowerUrl.endsWith('.doc') || lowerUrl.endsWith('.docx')) type = 'doc';
			else type = 'pdf';
		} else if (content.source_type === "Website URL") {
			type = 'web';
		} else if (content.source_type.toLowerCase().includes('youtube')) {
			type = 'youtube';
		} else {
			type = content.source_type.toLowerCase();
		}
	} else if (content.videoID || content.youtube_id || (content.metadata && content.metadata.videoId)) {
		type = 'youtube';
	} else if (content.file_path || content.pdf_url || (content.source_url && content.source_url.includes('.pdf'))) {
		type = 'pdf';
	} else if (content.url && content.content) {
		type = 'web';
	} else if (content.video_url) {
		type = 'video';
	}
	return type;
}

export function buildContextForAI(currentContent, contentType) {
	if (!currentContent) return '';

	const type = (contentType || 'text').toLowerCase();

	try {
		switch (type) {
			case 'youtube': {
				let context = '';
				if (currentContent.transcript && typeof currentContent.transcript === 'string' && currentContent.transcript.trim() !== '') {
					context = currentContent.transcript;
				} else if (currentContent.content && typeof currentContent.content === 'string' && currentContent.content.trim() !== '') {
					context = currentContent.content;
				} else {
					const videoId = currentContent.videoID || 
						(currentContent.metadata && currentContent.metadata.videoId) || 
						currentContent.source_id || 
						currentContent.youtube_id;

					context = `This is a YouTube video with ID: ${videoId}.`;
					if (currentContent.title) context += ` The title of the video is: "${currentContent.title}".`;
					if (currentContent.description) context += ` The video description is: "${currentContent.description}".`;
				}
				return context;
			}
			case 'pdf':
			case 'txt':
			case 'doc':
			case 'docx':
				return currentContent.content || '';
			case 'web':
				return currentContent.content || '';
			case 'video':
				return currentContent.transcript || currentContent.content || '';
			case 'text':
			default:
				return currentContent.content || currentContent.text_content || '';
		}
	} catch (error) {
		console.error("Error extracting context:", error);
		return `Unable to extract content from this ${type} resource. Please ask general questions about the topic.`;
	}
}

export function buildContextWithMeta(currentContent, contentType, baseContext) {
	let contextWithMeta = baseContext || '';
	if (!currentContent) return contextWithMeta;

	if ((contentType || '').toLowerCase() === 'youtube') {
		const videoTitle = currentContent?.title || "YouTube Video";
		const videoId = currentContent.videoID || 
			(currentContent.metadata && currentContent.metadata.videoId) || 
			currentContent.source_id || 
			currentContent.youtube_id;

		contextWithMeta = `TITLE: ${videoTitle}\nTYPE: YouTube Video\nVIDEO_ID: ${videoId}\n\n${baseContext}`;
	} else if (currentContent?.title) {
		contextWithMeta = `TITLE: ${currentContent.title}\n\n${baseContext}`;
	}
	return contextWithMeta;
}
